import React from 'react';
import visa from '../assets/card-brands/visa.svg?raw';
import mastercard from '../assets/card-brands/mastercard.svg?raw';
import amex from '../assets/card-brands/amex.svg?raw';
import elo from '../assets/card-brands/elo.svg?raw';
import hipercard from '../assets/card-brands/hipercard.svg?raw';
import diners from '../assets/card-brands/diners.svg?raw';
import maestro from '../assets/card-brands/maestro.svg?raw';
import { brandLabel } from '../utils/cardBrand.js';

/**
 * Brand marks keyed by the backend CardBrandEnum names the acquisition form works with.
 * The SVGs are the flat-rounded set already used by the payment link checkout.
 */
const BRAND_SVG = {
  Visa: visa,
  MasterCard: mastercard,
  AmericanExpress: amex,
  Elo: elo,
  Hipercard: hipercard,
  DinersClub: diners,
  Maestro: maestro
};

/**
 * Renders the brand logo, or nothing when the brand has no mark in the set.
 *
 * @param {{ brand: string, width?: number, className?: string }} props
 */
export function CardBrandIcon({ brand, width = 32, className }) {
  const svg = BRAND_SVG[brand];
  if (!svg) return null;

  return (
    <span
      className={className}
      role="img"
      aria-label={brandLabel(brand)}
      style={{ width, display: 'inline-flex' }}
      dangerouslySetInnerHTML={{ __html: svg }}
    />
  );
}
